import { Injectable } from "@angular/core";
import { CanActivate, UrlTree } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class SpecialtyGuard implements CanActivate {
    constructor() {}

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!sessionStorage.getItem("hcpSpecialty")) {
            return false;
        }
        return true;
    }
}
